<section
  class="hero-section"
  [ngClass]="{
    'flex justify-between container': (heroData()?.banners?.length || 0) < 2,
  }">
  <!-- image slider -->
  @if ((heroData()?.banners?.length || 0) > 1) {
    <pwj-begin-page-slider
      [mediaData]="heroData()?.banners"></pwj-begin-page-slider>
  } @else {
    <div class="hero-section__image-container">
      <img
        class="hero-section__image"
        [ngSrc]="
          heroData()?.banners?.[0]?.cropped_url?.toLowerCase() ||
          heroData()?.banners?.[0]?.url
            ? baseUrl +
              (heroData()?.banners?.[0]?.cropped_url?.toLowerCase() ||
                heroData()?.banners?.[0]?.url)
            : 'assets/images/mock-image/portfolio-hero.jpg'
        "
        width="983"
        height="476"
        priority
        alt="" />
    </div>
  }

  <div class="hero-section__content">
    <!-- business card -->
    <pwj-home-supplier-card
      class="hero-section__business-card"
      [isPortfolio]="true"
      [ngClass]="{
        '!m-0': (heroData()?.banners?.length || 0) < 2,
      }"
      [supplierCardData]="supplierData"
      [unSelectable]="true"></pwj-home-supplier-card>

    <!-- contact us button -->
    <ng-template [pwjHasAccess]="[roles.ViewBusinessContactInfo]">
      <pwj-button
        class="submit-btn"
        variant="primary"
        size="large"
        icon="chevron-right"
        [rotateIconInRtl]="true"
        [iconReversePosition]="true"
        (clicked)="openBusinessInfoBox()"
        >{{ 'global.contactUs' | translate }}</pwj-button
      >
    </ng-template>
  </div>
</section>
